<nav (clickOutside)="resetNavigationSelection()" *ngIf="navigationData$ | async as navigationData">
    <ul>
        <li *ngFor="let navigationEntry of navigationData | slice: 0:MAX_MAIN_ITEMS; let i = index" class="navigation-item">
            <ng-container *ngTemplateOutlet="topNavigationItem; context: { $implicit: navigationEntry, index: i }"></ng-container>
            <div class="dropdown desktop">
                <div class="row">
                    <div class="container navigation-item-sub segment">
                        <ng-container
                            *ngFor="let navigationEntryLevel1 of navigationEntry.Children | slice: 0:MAX_BUSINESSFIELD_ITEMS; let j = index"
                        >
                            <ng-container
                                *ngTemplateOutlet="
                                    inputLabelPairItem;
                                    context: {
                                        name: 'siteNavigationSecondLevelSelectedSegment' + i,
                                        id: 'navbar-toggle-segment-' + i + '-level-' + i + '-item-' + j,
                                        value: 'navbartogglesegment' + i + 'level' + i + 'item' + j,
                                        inputClass: 'site-navigation-third-level-selected-segment',
                                        labelClass: getCssClassByBusinessField(
                                            navigationEntryLevel1.TechnicalName.toLowerCase(),
                                            'underline'
                                        ),
                                        label: navigationEntryLevel1.DisplayName,
                                        cookieBusinessField: navigationEntryLevel1.TechnicalName
                                    }
                                "
                            ></ng-container>
                            <div class="container navigation-item-sub-content">
                                <div class="row">
                                    <div
                                        class="column"
                                        *ngFor="
                                            let navigationEntryLevel2 of navigationEntryLevel1.Children
                                                | slice: 0:MAX_BUSINESSFIELD_COLUMNS;
                                            let k = index
                                        "
                                    >
                                        <ng-container
                                            *ngTemplateOutlet="
                                                inputLabelPairItem;
                                                context: {
                                                    name: 'siteNavigationThirdLevelSelectedSegment' + i,
                                                    id: 'navbar-toggle-segment-' + i + '-level-' + i + '-item-' + j + '-child-' + k,
                                                    value: 'navbartogglesegment' + i + 'level' + i + 'item' + j + 'child' + k,
                                                    inputClass: '',
                                                    labelClass:
                                                        'headline ' +
                                                        getCssClassByBusinessField(
                                                            navigationEntryLevel1.TechnicalName.toLowerCase(),
                                                            'font'
                                                        ),
                                                    label: navigationEntryLevel2.DisplayName,
                                                    cookieBusinessField: navigationEntryLevel1.TechnicalName
                                                }
                                            "
                                        ></ng-container>

                                        <ng-container
                                            *ngTemplateOutlet="
                                                dropdownChild;
                                                context: {
                                                    $implicit: navigationEntryLevel2,
                                                    cookieBusinessField: navigationEntryLevel1.TechnicalName,
                                                    counter: k,
                                                    parentDisplayName: navigationEntryLevel2.DisplayName,
                                                    parentParentDisplayName: navigationEntryLevel1.DisplayName,
                                                    parentParentParentDisplayName: navigationEntry.DisplayName
                                                }
                                            "
                                        ></ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</nav>

<ng-template let-index="index" let-navigationEntry #topNavigationItem>
    <ng-container *ngIf="model$ | async as model">
        <ng-container *ngIf="model['sitenavigationTopSegmentSelected' + index]">
            <input
                type="checkbox"
                [(ngModel)]="model['sitenavigationTopSegmentSelected' + index].selected"
                [id]="'navbar-toggle-segment-' + index"
                [ngModelOptions]="{ standalone: true }"
            />

            <label
                class="dropdown-label-navbar"
                [ngClass]="getCssClassByBusinessField('draeger', 'underline')"
                [for]="'navbar-toggle-segment-' + index"
                (click)="selectOnlyClicked(index, navigationEntry)"
            >
                {{ navigationEntry.DisplayName }}
            </label>
        </ng-container>
    </ng-container>
</ng-template>
<ng-template let-navigationEntryLevel2 #dropdownChild>
    <div class="dropdown-child">
        <ul class="reset">
            <li *ngFor="let link of navigationEntryLevel2.Children | slice: 0:MAX_LINKS_PER_COLUMN; let linkIndex = index">
                <a da-link [link]="link.ResolvedDisplayUrl | localize">{{ link.DisplayName }}</a>
            </li>
        </ul>
    </div>
</ng-template>

<ng-template
    let-name="name"
    let-id="id"
    let-value="value"
    let-labelClass="labelClass"
    let-inputClass="inputClass"
    let-label="label"
    let-cookieBusinessField="cookieBusinessField"
    #inputLabelPairItem
>
    <ng-container *ngIf="model$ | async as model">
        <input type="radio" [(ngModel)]="model[name]" name="{{ name }}" value="{{ value }}" id="{{ id }}" class="{{ inputClass }}" />
        <label
            class="{{ labelClass }}"
            for="{{ id }}"
            [ngClass]="model[name] === value ? getCssClassByBusinessField(cookieBusinessField, 'font') : null"
        >
            {{ label }}
        </label>
    </ng-container>
</ng-template>
